import env from '../serviceWorker/environment/current.json';

type BoolEnvVars = 'DEV'|'PROD';
type StringEnvVars = Exclude<keyof typeof env, BoolEnvVars>;

//region Podmiana zmiennych środowiskowych na potrzeby testów
let envSubstitution: Partial<typeof env> = {};

export function setEnvSubstitution(envVar: StringEnvVars, value: string) {
    if (getEnvBool('DEV')) {
        envSubstitution[envVar] = value;
    }
}
export function setEnvSubstitutionBool(envVar: BoolEnvVars, value: boolean) {
    if (getEnvBool('DEV')) {
        envSubstitution[envVar] = value;
    }
}

function applyEnvSubstitutionsFromWindowGlobals() {
    if (self.envSubstitutions) {
        for (const key in self.envSubstitutions) {
            //@ts-ignore
            setEnvSubstitution(<StringEnvVars>key, self.envSubstitutions[key]);
        }
    }
}

export function clearEnvSubstitution() {
    if (getEnvBool('DEV')) {
        envSubstitution = {};
        applyEnvSubstitutionsFromWindowGlobals();
    }
}

if (getEnvBool('DEV')) {
    self.setEnvSubstitution = setEnvSubstitution;
    self.setEnvSubstitutionBool = setEnvSubstitutionBool;
    self.clearEnvSubstitution = clearEnvSubstitution;
    applyEnvSubstitutionsFromWindowGlobals();
}
//endregion

export function getEnv(envKeyName: StringEnvVars): string {
    return envSubstitution[envKeyName] || env[envKeyName];
}

export function getEnvBool(envKeyName: BoolEnvVars): boolean {
    return envSubstitution[envKeyName] || env[envKeyName];
}